<div #screenShareContainer>

</div>